/**
 * The equivalence a person writes for an offer whose units the unit table cannot measure in the
 * comparison unit ("1 Camión = 10.000 kg"). With it the offer gets a price per unit and competes.
 */
export interface QuotationEquivalence {
  equivalence: number | null
  setBy: string | null
  setAt: string | null
  quotedUnitLabel: string | null
}

/** How the api returns it, on each offer and as the answer of the save. */
export interface RawEquivalence {
  equivalence?: number | null
  equivalence_set_by?: string | null
  equivalence_set_at?: string | null
  quoted_unit_label?: string | null
}

export interface EquivalenceRepository {
  /** Writes the equivalence of a quotation line; null clears it. */
  save(quotationLineId: number, equivalence: number | null): Promise<QuotationEquivalence>
}

export function equivalenceOf(raw: RawEquivalence | null | undefined): QuotationEquivalence {
  return {
    equivalence: raw?.equivalence ?? null,
    setBy: raw?.equivalence_set_by ?? null,
    setAt: raw?.equivalence_set_at ?? null,
    quotedUnitLabel: raw?.quoted_unit_label ?? null,
  }
}

/** The number a person typed, with a comma or a dot as decimal mark; null unless it is greater than zero. */
export function parseEquivalence(text: string): number | null {
  const value = Number(text.trim().replace(',', '.'))
  return text.trim() !== '' && Number.isFinite(value) && value > 0 ? value : null
}

/** "$ 2.800 / kg"; just the amount when the line has no unit to compare in. */
export function perUnitText(amount: string, unit: string | null | undefined): string {
  return unit ? `${amount} / ${unit}` : amount
}
